export default __webpack_public_path__ + "static/media/logo.a6785a45.png";